import Image from "next/image";
import Link from "next/link";
import { BsArrowRight } from "react-icons/bs";
import { BASE_ASSETS_URL } from "../../constants/constants";
import Head from "next/head";

const boxData = [
  //   {
  //     id: 1,
  //     icon: "xero.svg",
  //     head: "Xero",
  //     subhead: "Finance",
  //     description: "Approve PO, Bills, Vendors and sync them within Xero.",
  //     link: "/integrations/xero",
  //   },
  //   {
  //     id: 2,
  //     icon: "zendesk.png",
  //     head: "Zendesk",
  //     subhead: "Customer Support",
  //     description:
  //       " Approve tickets, manage customer support requests and sync them within Zendesk.",
  //     link: "/integrations/zendesk",
  //   },
  //   {
  //     id: 3,
  //     icon: "forms.svg",
  //     head: "Google Form",
  //     subhead: "Capture Approval Request from Google Forms",
  //     description:
  //       "Capture approval request from Google Forms and sync them within Google Sheets.",
  //     link: "/integrations/googleform",
  //   },
  {
    id: 4,
    icon: "monday.png",
    head: "Monday",
    subhead: "Project Management",
    description: "Approve tasks, manage projects and sync them within Monday.",
    link: "/integrations/monday",
  },
  // {
  //    id:4,
  //    icon:"airtable.png",
  //    head:"Airtable",
  //    subhead:"New, Security & Compliance",
  //    description:"Automate audit log ingestion, alerting, and visualization with the Asana for Splunk integration.",
  //    link:"/integrations/airtable"
  // }
];

const Integrations = () => {
  return (
    <div>
      <Head>
        <meta charSet="utf-8" />
        <title> Approvals Integrations | BoloForms</title>
        <meta
          name="description"
          content="Boloforms helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
        />
        <meta name="geo.region" content="IN" />
        <meta name="geo.position" content="22.351115;78.667743" />
        <meta name="ICBM" content="22.351115, 78.667743" />
        <meta name="author" content="Boloforms" />
        <meta name="publisher" content="BoloForms " />
        <meta
          name="robots"
          content="INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
        />
        <link rel="canonical" href="https://www.boloforms.com/integrations" />

        <meta
          property="og:url"
          content="https://www.boloforms.com/integrations"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Approvals Integrations | Boloforms"
        />
        <meta
          property="og:description"
          content="Boloforms helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
        />
        <meta
          property="og:image"
          content="https://www.boloforms.com/_next/static/media/careers-banner.3c27d130.svg"
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta property="twitter:domain" content="https://bolosign.com" />
        <meta
          property="twitter:url"
          content="https://www.boloforms.com/integrations"
        />
        <meta
          name="twitter:title"
          content="Boloforms helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
        />
        <meta
          name="twitter:description"
          content="Boloforms helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
        />
        <meta
          name="twitter:image"
          content="https://www.boloforms.com/_next/static/media/careers-banner.3c27d130.svg"
        />
      </Head>
      <div className="absolute top-0 z-[-500] left-0 w-full bg-violet-500 h-[300px] md:h-[500px]"></div>
      <div className="mb-[100px]">
        <h3 className="text-[18px] font-medium text-white text-center">
          App Integrations
        </h3>
        <h1 className="text-[30px] md:text-[50px] font-medium text-white text-center mt-[20px] mb-[10px] md:mt-[30px] md:mb-[20px]">
          Your favorite tools in one place
        </h1>
        <p className="text-center font-extralight text-white text-[16px] md:text-[25px]">
          Connect with the tools your team uses every day.
        </p>
      </div>
      <div className="grid gap-[20px] grid-cols-1 md:grid-cols-2 max-w-[1000px] mx-auto">
        {boxData.map((data) => {
          return (
            <div
              key={data.key}
              className="integration-box flex items-start gap-[30px] border-[1px] rounded-[5px] bg-white shadow-lg hover:shadow-2xl p-[30px] h-[300px] ease-in duration-100"
            >
              <Image
                className="w-[50px]"
                src={`${BASE_ASSETS_URL}/integrations/${data.icon}`}
                alt="Picture of the author"
                width={50}
                height={50}
              />
              <div className="flex flex-col justify-between items-start h-[100%]">
                <div className="">
                  <div className="heading text-[20px]">{data.head}</div>
                  <div className="subhead mt-[5px] mb-[12px] text-[15px] text-slate-500">
                    {data.subhead}
                  </div>
                  <div className="description text-slate-600">
                    {data.description}
                  </div>
                </div>
                <Link
                  className="flex items-center font-medium hover:text-orange-500"
                  href="/integrations/[page]"
                  as={data.link}
                >
                  See More <BsArrowRight />
                </Link>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Integrations;
